module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.b06871f.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 281
// module chunks = 1